import commonPageService from 'mCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';
import './style.css';

function init() {
    commonPageService({ renderAfter: syncRender });
}

init();
